export default "__VITE_ASSET__b2c4d453__"